export default "__VITE_ASSET__CBNYmy$Z__"